import { render, staticRenderFns } from "./retail-digitization.vue?vue&type=template&id=6f7a1687&scoped=true&"
import script from "./retail-digitization.vue?vue&type=script&lang=js&"
export * from "./retail-digitization.vue?vue&type=script&lang=js&"
import style0 from "./retail-digitization.vue?vue&type=style&index=0&id=6f7a1687&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a1687",
  null
  
)

export default component.exports